//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import styled from 'styled-components';

import { InvisibleButton } from '@components/atoms/button/Button';
import { withTracking } from '@utils/withTracking';

export const ArrowButton = withTracking(
  styled(InvisibleButton)(
    ({ theme }) => `
    && {
      button svg {
        color: ${theme.colors.aliases.bodySecondary};
      }

      &:hover {
        button svg {
          color: ${theme.colors.aliases.bodySecondary};
        }
      }

      button > div {
        align-items: center;
      }

      button div:not(:first-child) {
        margin-left: 0;
      }
    }
`,
  ),
);
